import {OptionStyle, OptionType} from "../../types/ChainService";
import {Comparator} from "../../types/GenericTypes";
import {ascending} from "../../js/util/UtilFunctions";
import {IsoDate} from "../../pseudo-types/DateTypes";

export interface NewSimulationRecord {
    readonly name: string;
    readonly underlying: string;
    readonly initialBalance: number;
    readonly activeDate: IsoDate;
    readonly trades: Array<SimulationTradeRecord>;
}

export interface SimulationRecord extends NewSimulationRecord {
    readonly id: number;
}

export interface SimulationTradeRecord {
    readonly tradeDate: IsoDate;
    readonly price: number;
    readonly code: string;
    readonly quantity: number;
}

export interface SimulationCalculationResultRecord {
    readonly from: string;
    readonly to: string;
    readonly summaries: Array<SimulationCalculationRecord>;
    readonly contracts: Array<SimulationResultContract>;
}

export interface SimulationCalculationRecord {
    readonly asAt: string;
    readonly underlyingPrice: number;
    readonly newBusiness: number;
    readonly brokerage: number;
    readonly brokerageTax: number;
    readonly openFee: number;
    readonly openFeeTax: number;
    readonly exerciseFee: number;
    readonly exerciseFeeTax: number;
    readonly balance: number;
    readonly nlv: number;
    readonly pnl: number;
    readonly optionPremium: number;
    readonly best: number;
    readonly worst: number;
    readonly maxProfit: number;
    readonly maxLoss: number;
    readonly optionValues: Array<SimulationCalculationOptionValue>;
}

export interface SimulationCalculationOptionValue {
    readonly tradeDate: string;
    readonly code: string;
    readonly delta: number;
    readonly theo: number;
    readonly vol: number;
}

export interface SimulationResultContract {
    readonly code: string;
    readonly expiry: string;
    readonly strike: number;
    readonly style: OptionStyle;
    readonly tradeDate: string;
    readonly type: OptionType;
}

export function sortByCreatedAsc(): Comparator<SimulationRecord> {
    return (a, b) => ascending(a.id!, b.id!);
}
